import { Component } from "react";
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

interface PageNotFoundProps { }

class PageNotFound extends Component<PageNotFoundProps> {
    render() {
        return (
            <div className="page-not-found">
                <Container className="text-center">
                    <Card className="pb-5">
                        <h1>4<span className="text-primary">0</span>4</h1>
                        <Card.Body>
                            <Card.Title>The page you requested could not be found</Card.Title>
                            <Card.Text>
                                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                            </Card.Text>
                            <Button className="mt-5" variant="primary" as={Link as any} to={"/"}>
                                Back Home
                            </Button>
                        </Card.Body>
                    </Card>         
                </Container>
            </div>
        );
    }
}

export default PageNotFound;